import { connect } from 'react-redux'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'

// Containers
import BrowserSkillArea from 'app/views/containers/BrowserSkillArea'

// Redux
import { getContentById } from 'app/state/modules/content'

// Utils
import analytics from 'app/views/utils/analytics'
import isMobileDevice from 'app/views/utils/mobile'

const propTypes = {}
const defaultProps = {}


class DemoEs extends React.Component {
  constructor(props) {
    super(props)

    this.handleClickBack = this.handleClickBack.bind(this)
    this.handleClickCircle = this.handleClickCircle.bind(this)
    this.handleClickNext = this.handleClickNext.bind(this)
    this.handleClickDone = this.handleClickDone.bind(this)
  }

  componentDidMount() {
    localStorage.setItem('hackedu.language', 'es')
    this.props.getContentById('ffaf1a2c-563c-49ea-94f9-a9be559a21b9')
    analytics.page('demo-es')
  }

  handleClickBack(stepId) {
    analytics.track('demo-es-back', { stepId })
  }

  handleClickCircle(stepId) {
    analytics.track('demo-es-circle', { stepId })
  }

  handleClickDone(stepId) {
    analytics.track('demo-es-done', { stepId })
  }

  handleClickNext(stepId) {
    analytics.track('demo-es-next', { stepId })
  }

  render() {
    if (!Object.keys(this.props.contentDetails).includes('ffaf1a2c-563c-49ea-94f9-a9be559a21b9')) {
      return (
        <div className="uk-section uk-text-center">
          <div className="uk-container">
            <div data-uk-spinner="" />
          </div>
        </div>
      )
    }
    if (isMobileDevice()) {
      return (
        <div className="uk-section">
          <div className="uk-container uk-text-center">
            <h3 className="uk-text-bold">Parece que estás en el móvil...</h3>
            <p>
              Gracias por revisar nuestra demo mientras está en movimiento, pero nuestras
              herramientas no están disponibles en dispositivos móviles.
            </p>
            <Link className="uk-button uk-button-primary" to="/es/secure-development-training">Volver a la página principal</Link>
          </div>
        </div>
      )
    }
    const content = this.props.contentDetails['ffaf1a2c-563c-49ea-94f9-a9be559a21b9']
    return (
      <BrowserSkillArea
        handleClickBack={(stepId) => { this.handleClickBack(stepId) }}
        handleClickCircle={(stepId) => { this.handleClickCircle(stepId) }}
        handleClickNext={(stepId) => { this.handleClickNext(stepId) }}
        handleClickDone={(stepId) => { this.handleClickDone(stepId) }}
        title={content.title}
        description={content.description}
        steps={content.steps}
        tabs={content.tabs}
        ecsTaskDefinition={content.ecs_task_definition}
        currentProgress={0}
        hasTest={false}
        appType={content.app_type}
        contentType={content.content_type}
        lessonCompletionURL="/register"
        lessonCompletionText="Create an Account"
      />

    )
  }
}

DemoEs.propTypes = propTypes
DemoEs.defaultProps = defaultProps

const mapStateToProps = (state) => ({
  // content
  contentDetails: state.content.contentDetails,
})

const mapDispatchToProps = (dispatch) => ({
  getContentById: (contentId) => dispatch(getContentById(contentId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DemoEs))
